import { DateTime } from "luxon";

export function isValidTime(timeStr: string): boolean {
  if (timeStr.length === 0) return true;
  if (timeStr.length > 5) return false;

  return DateTime.fromFormat(timeStr, "HH:mm").isValid;
}

export function addDays(dateStr: string, daysToAdd: number): string {
  const datetime = DateTime.fromFormat(dateStr, "yyyy-MM-dd");
  return datetime.isValid ? datetime.plus({ days: daysToAdd }).toFormat("yyyy-MM-dd") : dateStr;
}

export function addMinutes(timeStr: string, minutesToAdd: number): string {
  if (timeStr.trim().length < 5) return timeStr;

  const datetime = DateTime.fromFormat(timeStr, "HH:mm");
  return datetime.isValid ? datetime.plus({ minutes: minutesToAdd }).toFormat("HH:mm") : timeStr;
}

export function isMidnightTransition(startTime: string, endTime: string): boolean {
  const time1 = DateTime.fromFormat(startTime, "HH:mm");
  const time2 = DateTime.fromFormat(endTime, "HH:mm");
  return time2 < time1;
}

export function formatTime(time: string): string {
  let digits = Array.from(time)
    .filter((char) => char >= "0" && char <= "9")
    .join("");

  if (digits.length > 4) {
    digits = digits.slice(0, 4);
  }

  if (digits.length <= 2) {
    return digits;
  }

  return digits.slice(0, 2) + ":" + digits.slice(2);
}

export function calculateEndTimeWithPint(dateTime: DateTime): DateTime {
  return dateTime.second === 0 ? dateTime : dateTime.plus({ minutes: 1 }).startOf("minute");
}
